export default [
    {
        key: '1',
        type: 'active',
        photo: '',

        auto: {
            name: 'Man',
            type: 'Lion’s Coach'
        },
        year: '2015',
        reg_number: 'K253BA 97',
        places: '52',
        price: {
            minute: {
                count: '50',
                unit: '₽/мин'
            },
            hour: {
                count: '3000',
                unit: '₽/ч'
            }
        },
        date_application: '1565163425313'
    },{
        key: '2',
        type: 'active',
        photo: '',
        excluded: true,
        auto: {
            name: 'Aan',
            type: 'Lion’s Coach'
        },
        year: '2010',
        reg_number: 'K253BA 97',
        places: '51',
        price: {
            minute: {
                count: '50',
                unit: '₽/мин'
            },
            hour: {
                count: '3000',
                unit: '₽/ч'
            }
        },
        date_application: '1565163425313'
    },{
        key: '3',
        type: 'active',
        photo: '',
        auto: {
            name: 'Ban',
            type: 'Lion’s Coach'
        },
        year: '2005',
        reg_number: 'K253BA 97',
        places: '50',
        price: {
            minute: {
                count: '50',
                unit: '₽/мин'
            },
            hour: {
                count: '3000',
                unit: '₽/ч'
            }
        },
        date_application: '1565163425313'
    },{
        key: '4',
        type: 'active',
        photo: '',
        auto: {
            name: 'Man',
            type: 'Lion’s Coach'
        },
        year: '2007',
        reg_number: 'K253BA 97',
        places: '49',
        price: {
            minute: {
                count: '50',
                unit: '₽/мин'
            },
            hour: {
                count: '3000',
                unit: '₽/ч'
            }
        },
        date_application: '1565163425313'
    },{
        key: '5',
        type: 'active',
        photo: '',
        auto: {
            name: 'Man',
            type: 'Lion’s Coach'
        },
        year: '2012',
        reg_number: 'K253BA 97',
        places: '48',
        price: {
            minute: {
                count: '50',
                unit: '₽/мин'
            },
            hour: {
                count: '3000',
                unit: '₽/ч'
            }
        },
        date_application: '1565163425313'
    },{
        key: '6',
        type: 'active',
        photo: '',
        auto: {
            name: 'Man',
            type: 'Lion’s Coach'
        },
        year: '1995',
        reg_number: 'K253BA 97',
        places: '47',
        price: {
            minute: {
                count: '50',
                unit: '₽/мин'
            },
            hour: {
                count: '3000',
                unit: '₽/ч'
            }
        },
        date_application: '1565163425313'
    },{
        key: '7',
        type: 'active',
        photo: '',
        excluded: true,
        auto: {
            name: 'Man',
            type: 'Lion’s Coach'
        },
        year: '1998',
        reg_number: 'K253BA 97',
        places: '46',
        price: {
            minute: {
                count: '50',
                unit: '₽/мин'
            },
            hour: {
                count: '3000',
                unit: '₽/ч'
            }
        },
        date_application: '1565163425313'
    }
]